import { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import IconClose from '@/assets/svgs/icon-close.svg?react'
import IconSuccess from '@/assets/svgs/icon-status-success.svg?react'
import IconError from '@/assets/svgs/icon-status-error.svg?react'
import Portal from '@/components/Portal'
import { ToastContext } from '@/context/ToastContext'

const ToastMini = ({ autoDelete = true, dismissTime = 5000, showCloseIcon = false }) => {
  const { toastList } = useContext(ToastContext)
  const [list, setList] = useState(toastList)

  useEffect(() => {
    setList([...toastList])
  }, [toastList])

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        deleteToast(toastList[0].id)
      }
    }, dismissTime)

    return () => clearInterval(interval)
  }, [toastList, autoDelete, dismissTime, list])

  function deleteToast(id) {
    const listIdx = list.findIndex(e => e.id === id)
    const sourceIdx = toastList.findIndex(e => e.id === id)
    list.splice(listIdx, 1)
    toastList.splice(sourceIdx, 1)
    setList([...list])
  }

  return (
    <Portal
      id="toast"
      className="fixed bottom-8 left-1/2 -translate-x-1/2 z-9999 flex flex-col items-center gap-5 max-phone:left-4 max-phone:right-4 max-phone:translate-x-0"
    >
      {list.map((toast, index) =>
        typeof toast.message !== 'undefined' ? (
          <div
            key={index}
            className={clsx(
              'toast max-w-111.5 max-phone:w-full max-phone:max-w-full rounded-[0.3125rem] shadow-base',
              {
                'toast--success bg-green-95': toast.type === 'success',
                'toast--error bg-red-95': toast.type === 'error',
              }
            )}
          >
            <div className="toast__content flex items-center py-3.5 px-4.5 type-body-2 max-tablet-p:justify-between">
              <span>
                {toast.type === 'success' && <IconSuccess className="block" />}
                {toast.type === 'error' && <IconError className="block" />}
              </span>
              <span className="toast__content__middle ml-3.5 max-tablet-p:flex-1">
                <div className="toast__message flex items-center gap-2">
                  <span>{toast.message}</span>
                  {toast.action && toast.action !== 'dismiss' && (
                    <span className="toast__action">{toast.action}</span>
                  )}
                </div>
              </span>
              <span className="toast__content__right ml-3.5">
                {toast.action === 'dismiss' && (
                  <button
                    className="toast__dismiss cursor-pointer p-0 font-semibold whitespace-nowrap bg-transparent border-none text-theme-50 font-[family-name:inherit] text-[length:inherit]"
                    onClick={() => deleteToast(toast.id)}
                  >
                    Dismiss
                  </button>
                )}
                {showCloseIcon && (
                  <div
                    className="toast__close link cursor-pointer"
                    onClick={() => deleteToast(toast.id)}
                  >
                    <IconClose />
                  </div>
                )}
              </span>
            </div>
          </div>
        ) : null
      )}
    </Portal>
  )
}

ToastMini.propTypes = {
  autoDelete: PropTypes.bool,
  dismissTime: PropTypes.number,
  showCloseIcon: PropTypes.bool,
}

export default ToastMini
